import * as React from 'react'

import { Box, Icon, Tag, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { DefaultShift } from 'modules/shift_management/lib/types'

interface ColorCodeDefaultShiftProps {
  defaultShift: DefaultShift
}

const ColorCodeDefaultShift = ({ defaultShift }: ColorCodeDefaultShiftProps) => {
  const { title, color, startAt, endAt, overnightShift } = defaultShift
  return (
    <Box
      flexDirection="row"
      width="fit-content"
      alignItems="center"
      justifyContent="spaceBetween"
      background="grey200"
      borderRadius={{ all: 'abs100' }}
      padding="s4"
      gap="s4"
    >
      <Icon.Small icon="circle" color={color || 'grey400'} />
      <Box maxWidth="s200">
        <Text size="200" weight="semibold" color="grey800" ellipsis>
          {title}.
        </Text>
      </Box>
      <Box alignItems="center" flexDirection="row" gap="s4">
        <Text size="200" weight="normal" color="grey800">
          {startAt} {i18n.t('common.to').toLowerCase()} {endAt}
        </Text>
        <Box paddingX="s4">
          {overnightShift && (
            <Tag type={Tag.Types.grey}>{i18n.t('shift_management.plus_1_day_tag')}</Tag>
          )}
        </Box>
      </Box>
    </Box>
  )
}

export interface Props {
  defaultShifts: DefaultShift[]
}

const DefaultShifts = ({ defaultShifts }: Props) => {
  return (
    <Box gap="s8">
      <Text.Normal size="300" weight="medium" color="grey1000">
        {i18n.t('shift_management.default_shift.colors.saved_shifts')}
      </Text.Normal>
      {defaultShifts.map((defaultShift: DefaultShift) => (
        <Box flexDirection="row" justifyContent="spaceBetween" key={defaultShift.id}>
          <ColorCodeDefaultShift defaultShift={defaultShift} />
        </Box>
      ))}
    </Box>
  )
}

export default DefaultShifts
